/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthResponseDto } from '../../models/auth-response-dto';

export interface AuthExternalCallbackGet$Json$Params {
  provider?: string;
  returnUrl?: string;
}

export function authExternalCallbackGet$Json(http: HttpClient, rootUrl: string, params?: AuthExternalCallbackGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthResponseDto>> {
  const rb = new RequestBuilder(rootUrl, authExternalCallbackGet$Json.PATH, 'get');
  if (params) {
    rb.query('provider', params.provider, {});
    rb.query('returnUrl', params.returnUrl, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuthResponseDto>;
    })
  );
}

authExternalCallbackGet$Json.PATH = '/auth/external/callback';
